import { ApiServices } from './apiServices';
import { ApiConfig } from './ApiConfigs';

/**
 * Create a shipment for an order (with optional driver assignment)
 * @param {object} data - { orderId, storeId, driverId?, pickupWarehouseId?, orderItemIds?, carrierName?, trackingNumber?, trackingUrl? }
 */
export const createShipment = async (data) => {
    const response = await ApiServices('POST', ApiConfig.SHIPMENTS, data);
    return response;
};

/**
 * Get all shipments (with optional filters)
 * @param {object} params - { orderId, storeId, driverId, status }
 */
export const getShipments = async (params = {}) => {
    const query = new URLSearchParams(params).toString();
    const url = query ? `${ApiConfig.SHIPMENTS}?${query}` : ApiConfig.SHIPMENTS;
    const response = await ApiServices('GET', url);
    return response;
};

/**
 * Get shipment by ID
 */
export const getShipmentById = async (id) => {
    const response = await ApiServices('GET', `${ApiConfig.SHIPMENTS}/${id}`);
    return response;
};

/**
 * Assign driver to shipment (admin)
 */
export const assignDriverToShipment = async (shipmentId, driverId) => {
    const response = await ApiServices('POST', `${ApiConfig.SHIPMENTS}/${shipmentId}/assign`, { driverId });
    return response;
};

/**
 * Driver accepts shipment (driver app only; requires driver JWT)
 */
export const acceptShipment = async (shipmentId) => {
    const response = await ApiServices('POST', `${ApiConfig.SHIPMENTS}/${shipmentId}/accept`, {});
    return response;
};

/**
 * Get shipments available for driver to accept (no driver assigned)
 */
export const getAvailableShipments = async (params = {}) => {
    const query = new URLSearchParams(params).toString();
    const url = query ? `${ApiConfig.SHIPMENTS}/available?${query}` : `${ApiConfig.SHIPMENTS}/available`;
    const response = await ApiServices('GET', url);
    return response;
};

/**
 * Update shipment status
 */
export const updateShipmentStatus = async (shipmentId, data) => {
    const response = await ApiServices('PUT', `${ApiConfig.SHIPMENTS}/${shipmentId}/status`, data);
    return response;
};

/**
 * Delete shipment (soft delete)
 */
export const deleteShipment = async (shipmentId) => {
    const response = await ApiServices('DELETE', `${ApiConfig.SHIPMENTS}/${shipmentId}`);
    return response;
};
